import { createContext } from 'react';

const OverflowScrollContext = createContext();

export default OverflowScrollContext;
